import routes from './src/routes'
import store from './src/store'

export default {
  install (Vue, options) {
    options.router.addRoute(...routes)
    options.store.registerModule('storage', store)
  }
}
